document.addEventListener('DOMContentLoaded', function () {

  const CART_VARIANT_ID = 56237263323428; // Your static variant ID
  const DISCOUNT_CODE = 'FREE-AIR-FRESHENER'; // Your discount code

  const select = document.getElementById('variant-product-name');
  const button = document.getElementById('add-static-variant');
  const message = document.getElementById('variant-cart-message');

  if (!select || !button) {
    return;
  }

  button.addEventListener('click', async function () {

    const productName = select.value;

    // Validation
    if (!productName) {
      if (message) {
        message.textContent = 'Please select a product.';
        message.style.display = 'block';
      }
      return;
    }

    // Disable button while adding
    button.disabled = true;
    button.textContent = 'Adding...';

    if (message) {
      message.style.display = 'none';
    }

    try {

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: CART_VARIANT_ID,
              quantity: 1,
              properties: {
                'Bottle 1': productName
              }
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add product to cart.');
      }

      const data = await response.json();

      // Apply discount and go to cart
      window.location.href =
        '/discount/' +
        encodeURIComponent(DISCOUNT_CODE) +
        '?redirect=/cart';

    } catch (error) {

      console.error('Cart error:', error);

      if (message) {
        message.textContent =
          'Something went wrong. Please try again.';
        message.style.display = 'block';
      }

      button.disabled = false;
      button.textContent = 'Add to Cart';
    }

  });

});